module.exports = __webpack_public_path__ + "img/katarina_outside_20.867ea0bd.jpg";